import {useUser} from '@gaia/stores/user';
import AppButtons from '@map/AppButtons';
import PopupCloseButton from '@map/popups/PopupCloseButton';
import {useCallback, useState} from 'react';

import {
    SidebarAwareCenteredSnackbar,
    SidebarAwareCenteredSnackbarProps,
} from './SidebarAwareCenteredSnackbar';

const snackbarContentStyle = {
    backgroundColor: '#fff',
    color: 'inherit',
    '& .MuiSnackbarContent-message': {
        textAlign: 'center',
        whiteSpace: {sm: 'nowrap'},
    },
};

interface KnownRoutesSnackbarProps extends SidebarAwareCenteredSnackbarProps {
    show: boolean;
}

export default function KnownRoutesSnackbar({
    mapControlsOffset,
    show,
    ...props
}: KnownRoutesSnackbarProps) {
    const [state, setState] = useState<'ready' | 'closed'>('ready');
    const {hasMobileApp} = useUser();

    // @TODO: i18n
    const messageContent = hasMobileApp
        ? 'Saved hikes are synced to your mobile app.'
        : 'Download the mobile app to take this hike with you.';

    return (
        <SidebarAwareCenteredSnackbar
            {...props}
            autoHideDuration={15000}
            ContentProps={{
                sx: snackbarContentStyle,
            }}
            onClose={useCallback(() => setState('closed'), [])}
            open={show && state === 'ready'}
            mapControlsOffset={mapControlsOffset}
            message={
                <>
                    {messageContent}
                    {!hasMobileApp && (
                        <AppButtons
                            analyticsContext='known routes snackbar'
                            style={{marginTop: 8}}
                        />
                    )}
                </>
            }
            action={<PopupCloseButton onClick={useCallback(() => setState('closed'), [])} />}
        />
    );
}
